import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { useAnalytics, useError, useLoader, useNotification, useRefetch, useUpdateSpace, } from "@piiqtechnologies/ui-lib";
export const SpacePrivacyAction = ({ isPublic, spaceId, PrivacyComponent }) => {
    const intl = useIntl();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setRefetch } = useRefetch();
    const { setNotification } = useNotification();
    const analytics = useAnalytics();
    const [updateSpace, spaceUpdated, isUpdatingSpace, spaceUpdateError] = useUpdateSpace();
    const handleTogglePrivacy = () => {
        updateSpace(Object.assign({ _id: spaceId, isVisible: !isPublic }, (isPublic && { sgtEnabled: false })));
    };
    useEffect(() => {
        setLoader(isUpdatingSpace);
        return () => setLoader(false);
    }, [isUpdatingSpace]);
    useEffect(() => {
        if (spaceUpdateError) {
            setError(spaceUpdateError === null || spaceUpdateError === void 0 ? void 0 : spaceUpdateError.message);
        }
    }, [spaceUpdateError]);
    useEffect(() => {
        if (spaceUpdated) {
            setRefetch();
            analytics.track("Space Visibility Changed");
            setNotification(intl.formatMessage(messages.updateSpacePrivacyStateSuccess));
        }
    }, [spaceUpdated]);
    return React.createElement(PrivacyComponent, { togglePrivacy: handleTogglePrivacy });
};
export default SpacePrivacyAction;
